export default [
  {
    // eslint-disable-next-line no-script-url
    name: 'Javascript: The Weird Parts',
    ref: 'https://www.udemy.com/certificate/UC-FJV8DRT2/',
    provider: 'Udemy',
    extension: '11.5 hours',
    disciplines: [
      'Syntax Parsers, Execution Contexts, and Lexical Environments',
      'Creation and Hoisting',
      'The Scope Chain',
      'Asynchronous Callbacks',
      'Operator Precedence and Associativity',
      'Coercion',
      'By Value vs By Reference',
      'Object Functions And This',
      'Function Overloading',
      'Immediately Invoked Functions Expressions (IIFEs)',
      'Understanding Closures',
      'Function Factories, Closures and Callbacks',
      'call(), apply(), and bind()',
      'Functional Programming',
      'Classical vs Prototypal Inheritance',
      'Reflection and Extend',
    ],
  },

  {
    name: 'Angular 2',
    ref: 'https://www.udemy.com/certificate/UC-AOUWOOM1/',
    provider: 'Udemy',
    extension: '11.5 hours',
    disciplines: [
      'Concepts of Components, Templates, Services, and Dependency Injection',
      'Working with Templates, data binding and event handling',
      'Validating forms using the Angular Forms module',
      'Making HTTP requests and integrating with a backend using a REST API',
      'Setting up a production-ready build workflow using NPM and Webpack',
      'Handling navigation in a single-page application with the Angular Router',
      'Writing unit tests with Jasmine and running them with Karma',
    ],
  },

  {
    name: 'NodeJS & MongoDB',
    ref: 'https://www.udemy.com/certificate/UC-5EANJJIY/',
    provider: 'Udemy',
    extension: '15.5 hours',
    disciplines: [
      'Integrate MySQL and MongoDB',
      'Design Pattern MVC',
      'Express Framework, and EJS as view engine',
      'RESTful APIs',
      'Body-parser: and requests parameters',
      'Express-validator: validating your data',
      'Session and autenthication',
      'Cryptography MD5 with Crypto',
      'Connect-Multiparty: uploading files',
      'Websockets',
    ],
  },

  {
    name: 'ES6/7+ and TypeScript',
    ref: 'https://www.udemy.com/certificate/UC-SE2QGOCU/',
    provider: 'Udemy',
    extension: '7 hours',
    disciplines: [
      'ECMAScript 2015, 2016+',
      'Classes and Inheritance',
      'Webpack',
      'Typescript@2.2',
      'Typescript Static types',
      'Typescript Declarations',
      'Typescript Interfaces',
      'Composed types, types aliases and abstract classes',
      'Namespaces',
      'Method Decorators',
    ],
  },

  {
    name: 'Advanced React and Redux',
    ref: 'https://www.udemy.com/certificate/UC-9RIJ69TG/',
    provider: 'Udemy',
    extension: '21 hours',
    disciplines: [
      'Testing: Jest and Enzyme',
      'Testing: Reducers',
      'Testing: Simulate events',
      'Integration Tests',
      'Higher Order Components',
      'Cookie-based and token-based authentication',
      'Creating Redux middlewares',
      'State Validation Middleware',
      'Async Middlewares',
      'JSON Schema',
      'Scalable Architecture',
    ],
  },

  {
    name: 'Docker Crash Course',
    ref: 'https://www.udemy.com/certificate/UC-50X0IVO4/',
    provider: 'Udemy',
    extension: '3 hours',
    disciplines: [
      'Containerize applications with a microservices automate it using Dockerfile',
      `Scale with DockerSwarm, orchestrate and deploy large-scale applications
      across multiple hosts in the cloud`,
      'Best practices of working with Docker',
      'Setting up continuous integration workflows',
    ],
  },
];
